// authStore.ts
import { action, makeAutoObservable, observable } from "mobx";

class AuthStore {
  @observable accessToken: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  setAccessToken(token: string) {
    this.accessToken = token;
  }

  getAccessToken(): string | null {
    return this.accessToken;
  }
}

export const authStore = new AuthStore();
